module.exports = __webpack_public_path__ + "static/media/miniapp-qr.a9454d7b.jpg";